import gql from 'graphql-tag';
import { KinderConnectCaptureChildSettingFields } from './kinder-connect-capture-child-setting.fragment';
export const SetKinderConnectCaptureRequired = gql `
    mutation SetKinderConnectCaptureRequired($settings: [KinderConnectCaptureChildInput!]!) {
        attendance {
            childCheckins {
                setKinderConnectCaptureRequired(settings: $settings) {
                    ...KinderConnectCaptureChildSettingFields
                }
            }
        }
    }
    ${KinderConnectCaptureChildSettingFields}
`;
